module.exports = __webpack_public_path__ + "static/media/similar_tracks.44100342.svg";